import React from "react";
import { Brand } from "./Brand";
import { navLinks } from "../data/content";
export function Header() {
  return <header className="mx-auto flex h-[74px] max-w-[1440px] items-center justify-between border-b border-line px-[22px] sm:h-[88px] sm:px-7 lg:px-12" data-id="element-69" data-mp="2dnfk6bc4wwp2">
      <Brand data-id="element-70" data-mp="2nkka8m93pcb5" />
      <nav className="flex items-center gap-[30px] text-xs text-[#bbc2b4]" aria-label="Principal" data-id="element-71" data-mp="2nkal10vvr96i">
        {navLinks.map(l => <a key={l.href} href={l.href} className="hidden transition-colors duration-150 hover:text-fg sm:inline" data-id="element-72" data-mp="2rldy5fmjmr41">
            {l.label}
          </a>)}
        <a href="#unirme" className="rounded-lg border border-[#69765c] px-[13px] py-2.5 text-[11px] text-[#edf2e7] transition-colors duration-150 hover:border-lime hover:text-lime sm:px-[18px] sm:py-3 sm:text-xs" data-id="element-73" data-mp="31c8lyofftyrl">
          Unirme
        </a>
      </nav>
    </header>;
}